export default class HttpProvider {
  /* @ngInject */
  constructor($httpProvider) {
    this.$httpProvider = $httpProvider;
    this.BASE_PATH = '';
    this.$get = ['$http', '$q', HttpProvider.httpService];
  }

  addInterceptor(interceptor) {
    this.$httpProvider.interceptors.push(interceptor);
  }

  static httpService($http, $q) {
    const http = $http;
    http.all = $q.all;
    http.resolve = $q.resolve;
    http.reject = $q.reject;
    http.BASE_PATH = this.BASE_PATH;
    return http;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/http/http.provider.js